/**
 * Chatbot comprala.cl — Powered by Claude
 * ==========================================
 * INSTRUCCIONES DE INSTALACIÓN:
 * 1. En Shopify Admin > Online Store > Themes > Edit code
 * 2. Sube este archivo a Assets (botón "Add a new asset")
 * 3. Abre layout/theme.liquid
 * 4. Pega esto justo antes de </body>:
 *    <script src="{{ 'comprala-chatbot.js' | asset_url }}" defer></script>
 * 5. Reemplaza TU_API_KEY_AQUI con tu API key de Anthropic
 *
 * SEGURIDAD: Para producción, usa un proxy (Cloudflare Worker o
 * Vercel Function) en vez de exponer la API key en el frontend.
 * ==========================================
 */

(function () {

  /* ── CONFIGURACIÓN ─────────────────────────────────────── */
  const CONFIG = {
    apiKey: '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',
    endpoint: 'https://api.anthropic.com/v1/messages',
    model: 'claude-haiku-4-5-20251001',
    storeName: 'comprala.cl',
    storeEmail: 'info@comprala.cl',
    whatsapp: '+56954178251',
    accentColor: '#FF6B1A',
    accentDark: '#cc5100',
  };

  /* ── BASE DE CONOCIMIENTO (desde planilla Excel) ────────── */
  const FAQS = [
    {
      q: 'Intención de compra / qué busca el usuario',
      a: 'Perfecto! Cuéntame, ¿Qué buscas? 🔎 Prueba escribiendo un producto a la vez, usando palabras claves como por ejemplo: escritorios o celulares.'
    },
    {
      q: 'Solicita presupuesto o cotización',
      a: 'Si deseas comprar productos pero necesitas una cotización, especifícanos los productos y las cantidades que necesitas escribiéndonos al correo info@comprala.cl ¡Te esperamos!'
    },
    {
      q: 'Productos nuevos, recién llegados o nueva temporada',
      a: '¿Quieres saber los últimos lanzamientos y ofertas? Entra a la sección RECIEN LLEGADOS en nuestro sitio.'
    },
    {
      q: 'Consulta sobre stock o existencia de productos',
      a: 'Nuestros productos tienen stocks limitados, pues no contamos con demasiadas variedades de cada producto. ¡Pero ojo! siempre pueden volver a nuestra tienda.'
    },
    {
      q: 'Descuentos y promociones vigentes',
      a: '¡Puedes revisar mes a mes todos nuestros descuentos y promociones disponibles en nuestro sitio!'
    },
    {
      q: 'Estado de pedido con retiro en tienda',
      a: 'Cuando tu compra esté lista, te notificaremos por correo. Revisa el email de confirmación para conocer los detalles de tu retiro en tienda. Recuerda revisar tu Bandeja de entrada o SPAM.'
    },
    {
      q: 'Modificar dirección de envío',
      a: 'Para solicitar el cambio de dirección de envío debes comunicarte al correo info@comprala.cl comentando tu requerimiento. 📌 Recuerda tener a mano tu número de pedido, ya que lo necesitaremos para poder ayudarte.'
    },
    {
      q: 'Pedido excedió la fecha comprometida de entrega',
      a: 'Para ayudarte con lo sucedido envía un correo a info@comprala.cl con la siguiente información: ▪️ Número de pedido ▪️ Fecha en la que realizaste tu pedido ▪️ Dirección de envío que proporcionaste. ¡Nuestro equipo se pondrá en contacto contigo lo antes posible!'
    },
    {
      q: 'Seguimiento del pedido o estado del despacho',
      a: 'Para hacer seguimiento de tu pedido puedes solicitar la información a info@comprala.cl. También puedes revisar en el correo que te llegó al momento de hacer tu compra el link o número de seguimiento.'
    },
    {
      q: 'Devolución de dinero o nota de crédito',
      a: 'La devolución de dinero se hará a tu cuenta durante las siguientes 96 horas hábiles del trámite aceptado. Si ha pasado más tiempo, puedes escribir a info@comprala.cl con el número de tu compra.'
    },
    {
      q: 'Cambio de productos',
      a: 'Para cambiar un producto, envía un correo a info@comprala.cl con el número de orden y el motivo de cambio. Un representante se comunicará contigo para ayudarte en el proceso.'
    },
    {
      q: 'Devolución de productos',
      a: 'Para devolver un producto, envía un correo a info@comprala.cl con el número de orden y el motivo de devolución. Una ejecutiva de ventas se comunicará contigo para ayudarte en el proceso.'
    },
    {
      q: 'Garantía de los productos',
      a: 'Todos los productos de nuestra tienda cuentan con 30 días de garantía. Al ser productos OPENBOX o abiertos no cuentan con garantía legal, sin embargo nuestra empresa contribuye con 30 días de garantía por cualquier funcionamiento incorrecto.'
    },
    {
      q: 'Horario de despachos y entregas',
      a: 'Nuestras entregas son realizadas entre las 09:00 y 19:00 hrs. de lunes a viernes en días hábiles.'
    },
    {
      q: 'Courier o empresa de envíos',
      a: 'Trabajamos con diferentes empresas de courier. Dentro de Santiago operamos con HSL Express; a regiones también usamos Bluexpress y Starken. Al finalizar la compra verás las opciones disponibles para que elijas la mejor para ti.'
    },
    {
      q: 'Costo del despacho o envío',
      a: '📌 Los despachos dentro de la Región Metropolitana tienen un costo de $3.000. Los valores a regiones dependerán de cada localización y región de Chile. Podrás conocer el costo exacto al finalizar tu proceso de compra.'
    },
    {
      q: 'Plazos de entrega y tiempos de despacho',
      a: '📌 Los despachos dentro de la Región Metropolitana tienen un tiempo de entrega de 2 a 3 días hábiles. 📌 Los despachos a regiones tienen un tiempo de entrega de 5 a 7 días hábiles.'
    },
    {
      q: 'Problema con el monto cobrado o error en el pago',
      a: 'Lamentamos el problema con el cobro de tu pedido. Envíanos a info@comprala.cl la siguiente información: ▪️ Número de pedido ▪️ Detalles del problema de cobro. Te brindaremos una solución lo antes posible.'
    },
    {
      q: 'Error al pagar o no puede acceder a pantalla de pagos',
      a: 'Lamentamos las molestias causadas por la falla en el portal de pagos. Estamos trabajando para resolver el problema lo más rápido posible. Si persiste, contáctanos a info@comprala.cl.'
    },
    {
      q: 'Factura o cambio de documento de compra',
      a: 'Si necesitas factura, selecciona esa opción al finalizar tu compra. También puedes compartirnos tus datos de facturación al correo info@comprala.cl.'
    },
    {
      q: 'Medios de pago disponibles',
      a: 'Contamos con diferentes medios de pago: MercadoPago, Flow, Khipu, Débito y Crédito. También puedes comprar de manera presencial en nuestra bodega en Av. Las Parcelas 7950, Peñalolén, Santiago, de 10:00 a 16:00 hrs de lunes a viernes.'
    },
    {
      q: 'Copia o duplicado de boleta',
      a: 'Una copia de la boleta se enviará automáticamente a tu correo una vez que hayas realizado tu pedido. Si no te llega correctamente puedes solicitarla a info@comprala.cl.'
    },
    {
      q: 'Información de contacto de la tienda',
      a: 'Puedes comunicarte con nosotros a través de: 📱 WhatsApp: +56954178251 | 📞 Bodega: +562 2494 5836 | 📧 info@comprala.cl | Chat en vivo en el sitio | Redes sociales: Facebook, Instagram y TikTok.'
    },
    {
      q: 'Horarios de atención al cliente',
      a: 'Nuestros horarios de atención son de lunes a viernes de 09:00 a 17:00 hrs hábiles.'
    },
    {
      q: 'Retiro presencial en bodega',
      a: 'Puedes retirar y comprar directamente en nuestra Bodega de distribución en Av. Las Parcelas 7950, Peñalolén, Santiago, de lunes a viernes de 10:00 a 16:00 horas.'
    },
    {
      q: 'Venta mayorista o por grandes cantidades',
      a: 'Actualmente no contamos con compras al por mayor, solo al detalle.'
    },
  ];

  /* ── SYSTEM PROMPT ──────────────────────────────────────── */
  function buildSystem() {
    const faqText = FAQS.map(f => `Situación: ${f.q}\nRespuesta: ${f.a}`).join('\n\n');
    return `Eres el asistente virtual de comprala.cl, una tienda online chilena que vende productos nuevos, seminuevos y openbox con importantes descuentos. Tienen bodega física en Av. Las Parcelas 7950, Peñalolén, Santiago.

INSTRUCCIONES:
- Responde siempre en español, de forma amigable, breve y directa (máximo 3-4 oraciones).
- Usa "tú" para dirigirte al cliente, con tono cercano y servicial.
- Basa tus respuestas en la base de conocimiento provista. Si no sabes algo específico, deriva al correo info@comprala.cl o WhatsApp +56954178251.
- No inventes precios ni stock de productos específicos.
- Si el usuario quiere comprar algo concreto, sugiere buscar en el sitio usando palabras clave.
- Para el CyberDay 2026 (1 al 3 de junio), menciona que habrá descuentos especiales en el sitio.

BASE DE CONOCIMIENTO:
${faqText}`;
  }

  /* ── ESTILOS ────────────────────────────────────────────── */
  const CSS = `
    #cmp-chat-btn {
      position: fixed; bottom: 24px; right: 24px; z-index: 9999;
      width: 58px; height: 58px; border-radius: 50%;
      background: ${CONFIG.accentColor}; border: none; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 20px rgba(255,107,26,0.4); transition: transform .2s, background .2s;
    }
    #cmp-chat-btn:hover { transform: scale(1.08); background: ${CONFIG.accentDark}; }
    #cmp-chat-btn svg { width: 26px; height: 26px; fill: white; }
    #cmp-badge {
      position: absolute; top: -3px; right: -3px;
      width: 20px; height: 20px; border-radius: 50%;
      background: #fff; color: ${CONFIG.accentColor};
      font-size: 11px; font-weight: 700;
      display: flex; align-items: center; justify-content: center;
      border: 2px solid ${CONFIG.accentColor};
    }
    #cmp-window {
      position: fixed; bottom: 96px; right: 24px; z-index: 9998;
      width: 370px; border-radius: 18px; overflow: hidden;
      display: none; flex-direction: column;
      box-shadow: 0 12px 40px rgba(0,0,0,0.45);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      max-height: 580px; border: 1px solid #2a2a2a;
    }
    #cmp-window.open { display: flex; animation: cmpSlideUp .25s ease; }
    @keyframes cmpSlideUp { from { opacity:0; transform: translateY(12px); } to { opacity:1; transform: translateY(0); } }
    #cmp-header {
      background: ${CONFIG.accentColor}; padding: 14px 16px;
      display: flex; align-items: center; gap: 10px; flex-shrink: 0;
    }
    #cmp-avatar {
      width: 40px; height: 40px; border-radius: 50%;
      background: white; display: flex; align-items: center;
      justify-content: center; font-weight: 700; font-size: 15px;
      color: ${CONFIG.accentColor}; flex-shrink: 0;
    }
    #cmp-header-info { flex: 1; }
    #cmp-header-info .hname { color: white; font-weight: 600; font-size: 14px; margin: 0; line-height: 1.3; }
    #cmp-header-info .hsub { color: rgba(255,255,255,0.82); font-size: 11px; margin: 2px 0 0; }
    #cmp-close {
      background: none; border: none; cursor: pointer;
      color: white; font-size: 22px; line-height: 1; padding: 4px;
      opacity: 0.85; transition: opacity .15s;
    }
    #cmp-close:hover { opacity: 1; }
    #cmp-messages {
      flex: 1; overflow-y: auto; padding: 14px 14px 8px;
      display: flex; flex-direction: column; gap: 10px;
      background: #1a1a1a; min-height: 280px;
    }
    .cmp-msg {
      max-width: 86%; padding: 10px 13px;
      border-radius: 16px; font-size: 13.5px; line-height: 1.55;
      animation: cmpFadeIn .2s ease;
    }
    @keyframes cmpFadeIn { from { opacity:0; transform:translateY(4px); } to { opacity:1; } }
    .cmp-msg.bot { background: #2a2a2a; color: #eee; align-self: flex-start; border-bottom-left-radius: 4px; }
    .cmp-msg.user { background: ${CONFIG.accentColor}; color: white; align-self: flex-end; border-bottom-right-radius: 4px; }
    .cmp-msg.typing { background: #252525; color: #666; align-self: flex-start; font-size: 12px; font-style: italic; }
    #cmp-quickbtns {
      display: flex; gap: 6px; flex-wrap: wrap;
      padding: 8px 14px 6px; background: #1a1a1a; border-top: 1px solid #222;
    }
    .cmp-qbtn {
      background: none; border: 1px solid ${CONFIG.accentColor}55;
      color: ${CONFIG.accentColor}; border-radius: 20px;
      padding: 4px 11px; font-size: 11px; cursor: pointer;
      transition: background .15s, border-color .15s; white-space: nowrap;
      font-family: inherit;
    }
    .cmp-qbtn:hover { background: ${CONFIG.accentColor}22; border-color: ${CONFIG.accentColor}; }
    #cmp-inputrow {
      display: flex; gap: 8px; padding: 10px 14px;
      background: #111; align-items: center; flex-shrink: 0;
      border-top: 1px solid #222;
    }
    #cmp-input {
      flex: 1; background: #252525; border: 1px solid #333;
      border-radius: 22px; padding: 9px 14px;
      color: #eee; font-size: 13px; outline: none;
      font-family: inherit; transition: border-color .2s;
    }
    #cmp-input::placeholder { color: #555; }
    #cmp-input:focus { border-color: ${CONFIG.accentColor}88; }
    #cmp-send {
      width: 38px; height: 38px; border-radius: 50%;
      background: ${CONFIG.accentColor}; border: none; cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; transition: background .15s;
    }
    #cmp-send:hover { background: ${CONFIG.accentDark}; }
    #cmp-send svg { width: 15px; height: 15px; fill: white; }
    #cmp-footer {
      text-align: center; padding: 6px 14px;
      background: #111; font-size: 10px; color: #3a3a3a;
      flex-shrink: 0;
    }
    @media (max-width: 420px) {
      #cmp-window { width: calc(100vw - 20px); right: 10px; bottom: 82px; }
      #cmp-chat-btn { right: 16px; bottom: 16px; }
    }
  `;

  /* ── HTML ───────────────────────────────────────────────── */
  const HTML = `
    <button id="cmp-chat-btn" aria-label="Abrir chat de ayuda">
      <div id="cmp-badge">1</div>
      <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 10H6V10h12v2zm0-3H6V7h12v2z"/></svg>
    </button>

    <div id="cmp-window" role="dialog" aria-label="Chat de ayuda comprala.cl">
      <div id="cmp-header">
        <div id="cmp-avatar">C</div>
        <div id="cmp-header-info">
          <p class="hname">Asistente comprala.cl</p>
          <p class="hsub">En linea · respuesta inmediata</p>
        </div>
        <button id="cmp-close" aria-label="Cerrar chat">&times;</button>
      </div>

      <div id="cmp-messages"></div>

      <div id="cmp-quickbtns">
        <button class="cmp-qbtn" data-q="¿Cuánto demora el despacho?">Despacho</button>
        <button class="cmp-qbtn" data-q="¿Qué garantía tienen los productos?">Garantia</button>
        <button class="cmp-qbtn" data-q="¿Cuáles son los medios de pago?">Pagos</button>
        <button class="cmp-qbtn" data-q="¿Cuánto cuesta el envío?">Costo envio</button>
        <button class="cmp-qbtn" data-q="¿Cómo puedo hacer seguimiento de mi pedido?">Mi pedido</button>
        <button class="cmp-qbtn" data-q="¿Dónde están ubicados?">Ubicacion</button>
      </div>

      <div id="cmp-inputrow">
        <input id="cmp-input" type="text" placeholder="Escribe tu pregunta..." maxlength="400" aria-label="Mensaje" />
        <button id="cmp-send" aria-label="Enviar mensaje">
          <svg viewBox="0 0 24 24"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>
        </button>
      </div>
      <div id="cmp-footer">Asistente virtual comprala.cl · Powered by Claude AI</div>
    </div>
  `;

  /* ── LÓGICA ─────────────────────────────────────────────── */
  function init() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    const container = document.createElement('div');
    container.innerHTML = HTML;
    document.body.appendChild(container);

    const btn      = document.getElementById('cmp-chat-btn');
    const win      = document.getElementById('cmp-window');
    const closeBtn = document.getElementById('cmp-close');
    const input    = document.getElementById('cmp-input');
    const sendBtn  = document.getElementById('cmp-send');
    const badge    = document.getElementById('cmp-badge');
    const msgs     = document.getElementById('cmp-messages');
    const qbtns    = document.querySelectorAll('.cmp-qbtn');

    let history  = [];
    let isOpen   = false;
    let isTyping = false;

    appendMsg('¡Hola! 👋 Soy el asistente de <strong>comprala.cl</strong>. Puedo ayudarte con despachos, garantías, pagos, cambios y más. ¿En qué te ayudo?', 'bot');

    btn.addEventListener('click', () => {
      isOpen = !isOpen;
      win.classList.toggle('open', isOpen);
      if (isOpen) { badge.style.display = 'none'; input.focus(); }
    });

    closeBtn.addEventListener('click', () => { isOpen = false; win.classList.remove('open'); });

    qbtns.forEach(b => b.addEventListener('click', () => send(b.dataset.q)));

    input.addEventListener('keydown', e => { if (e.key === 'Enter' && !e.shiftKey) send(); });
    sendBtn.addEventListener('click', () => send());

    function send(text) {
      const msg = (text || input.value).trim();
      if (!msg || isTyping) return;
      input.value = '';
      appendMsg(msg, 'user');
      history.push({ role: 'user', content: msg });
      callClaude();
    }

    async function callClaude() {
      isTyping = true;
      const typingEl = appendMsg('Escribiendo...', 'typing');

      try {
        const res = await fetch(CONFIG.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': CONFIG.apiKey,
            'anthropic-version': '2023-06-01',
            'anthropic-dangerous-direct-browser-access': 'true'
          },
          body: JSON.stringify({
            model: CONFIG.model,
            max_tokens: 350,
            system: buildSystem(),
            messages: history
          })
        });

        const data = await res.json();
        const reply = data.content?.[0]?.text ||
          'Lo siento, no pude procesar tu consulta. Escríbenos a ' + CONFIG.storeEmail;

        typingEl.remove();
        appendMsg(reply, 'bot');
        history.push({ role: 'assistant', content: reply });

      } catch (err) {
        typingEl.remove();
        appendMsg('Hubo un problema de conexión. Contáctanos a ' + CONFIG.storeEmail + ' o WhatsApp ' + CONFIG.whatsapp, 'bot');
        console.error('[comprala-chat]', err);
      }

      isTyping = false;
    }

    function appendMsg(html, type) {
      const div = document.createElement('div');
      div.className = 'cmp-msg ' + type;
      div.innerHTML = html;
      msgs.appendChild(div);
      msgs.scrollTop = msgs.scrollHeight;
      return div;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
